import GodBanner from '@/components/layout/GodBanner';
import VerifactuAlarmaBanner from '@/components/layout/VerifactuAlarmaBanner';
import TopBar from '@/components/layout/TopBar';
import { PageErrorBoundary } from '@/components/ErrorBoundary';
import { cn } from '@/lib/utils';
import { AdvisorSessionProvider } from './AdvisorSessionContext';

/**
 * AdvisorShell — chrome del workspace de Contabilidad · Modo Asesor (AD-2a).
 *
 * Lo monta el **Layout Dispatcher** (`src/pages/Layout.jsx`) EN LUGAR del chrome
 * global (Sidebar + TopBar) cuando el asesor está en god_mode, el flag
 * `ADVISOR_MODE` está activo y la ruta pertenece al workspace contable/fiscal
 * (`isAdvisorScopedPath`). Los overlays compartidos (⌘K `CommandMenu`,
 * `CompanySwitcher`, `AIPanel`, `Toaster`…) los sigue montando el Layout fuera
 * de este componente — aquí solo va el chrome.
 *
 * Compone: **GodModeBar** (reusa el `GodBanner` existente, self-gated por
 * isAsesor+company) + **TopBar** reutilizado (mismos props que en Layout) +
 * `main{children}`. NO renderiza la Sidebar global de módulos: el sub-sidebar
 * Focused del asesor llega en AD-2b (dentro de `AccountingHub`); las páginas
 * contables siguen trayendo su propio sub-sidebar mientras tanto.
 *
 * Estilos Tailwind/shadcn (densidad cozy). `.client-area` aplica el filtro de
 * saturación de cliente, igual que el `main` del Layout clásico en god_mode.
 */
export default function AdvisorShell({
  children,
  user,
  currentCompany,
  currentPageName,
  breadcrumbPath,
  pageTitleKey,
  setMobileMenuOpen,
  setShowCommandMenu,
  setShowKeyboardShortcuts,
  onStartTour,
  onLogout,
  aiPanelOpen,
  onToggleAIPanel,
  onSwitchCompany,
}) {
  return (
    <AdvisorSessionProvider>
      <div data-testid="advisor-shell" className="min-h-screen flex flex-col bg-background text-foreground">
        {/* Modo Dios — banner existente (self-gated). En el dispatcher
            shouldUseAdvisorShell ya implica inGodMode, así que es visible. */}
        <GodBanner />
        {/* F5 · la alarma de integridad No VERI*FACTU también en Modo Asesor: el asesor
            trabaja sobre la empresa y tiene que verla. Self-gates por el modo. */}
        <VerifactuAlarmaBanner />
        <TopBar
          currentPageName={currentPageName}
          breadcrumbPath={breadcrumbPath}
          pageTitleKey={pageTitleKey}
          user={user}
          setMobileMenuOpen={setMobileMenuOpen}
          setShowCommandMenu={setShowCommandMenu}
          setShowKeyboardShortcuts={setShowKeyboardShortcuts}
          onStartTour={onStartTour}
          onLogout={onLogout}
          aiPanelOpen={aiPanelOpen}
          onToggleAIPanel={onToggleAIPanel}
          onSwitchCompany={onSwitchCompany}
          currentCompany={currentCompany}
        />
        <main id="main-content" className={cn('flex-1 min-w-0 p-3 sm:p-4 lg:p-6', 'client-area')} tabIndex={-1}>
          <PageErrorBoundary>{children}</PageErrorBoundary>
        </main>
      </div>
    </AdvisorSessionProvider>
  );
}
